import {
  type TimeDisplayMode,
  formatTimeByMode,
} from "@/shared/components/visualization/WorkspaceCtx";

/**
 * Formats a nanosecond epoch string for display in a text field.
 * Falls back to the raw string if parsing fails.
 */
export function formatDatetimeValue(
  value: string,
  mode: TimeDisplayMode,
  earliestTime: bigint | null | undefined,
): string {
  if (value === "") {
    return "";
  }
  try {
    return formatTimeByMode(BigInt(value), mode, earliestTime);
  } catch {
    return value;
  }
}
